export async function loadRotateUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("rotate", async (container) => {
        const { RotateUpdater } = await import("./RotateUpdater.js");
        return new RotateUpdater(container);
    }, refresh);
}
